function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.143 3.571c0 1.103-.897 2-2 2s-2-.897-2-2c0-1.102.897-2 2-2s2 .898 2 2zM11 6.594c-.286.075-.571.12-.857.12a3.149 3.149 0 01-2.286-5.308A1.103 1.103 0 007 1c-.629 0-1.143.514-1.143 1.143v.166A3.994 3.994 0 003 6.143V9.57l-1.143 1.143v.572h10.286v-.572L11 9.571V6.594zM7 13c.634 0 1.143-.509 1.143-1.143H5.857A1.143 1.143 0 007 13z",
  fill: "currentColor"
});

var SvgNotification2 = function SvgNotification2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgNotification2;